import {
	browser,
	btn,
	Button,
	DateTime,
	DateField,
	datefield,
	Field,
	fieldset,
	Form,
	form,
	Notifier,
	select,
	SelectField,
	tbar,
	textfield,
	Window
} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {documentTypesStore} from "./data/DocumentTypeStore.js";
import {ServerApi} from "./util/ServerApi.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {BlobEntity, ParticipantDocument} from "./data/ParticipantsStore.js";

export class EditDocumentDialog extends Window {
	fileUploadFld: Field | undefined;
	fileUploadBtn: Button;
	fileUploadDeleteBtn: Button;
	fileInfoFld: Field;
	// documentTypeFld: ComboBox;
	documentTypeFld: SelectField;
	documentDateFld: DateField;
	expirationDateFld: DateField;
	form: Form;
	documentId: string | undefined;

	constructor() {
		super();

		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;
		this.title = t("Document");
		this.form = form({
				flex: 1,
				cls: "vbox",
				handler: async () => {
					const v = this.form.value;
					if (!v.blobId) {
						this.fileInfoFld.setInvalid(t("This field is required"));
						return false;
					}

					const cp = CurrentParticipant.get(),
						participantDocs = cp.documents!;
					if (this.documentId) {
						for (const currentDocument of participantDocs) {
							if (currentDocument.id === this.documentId!) {
								Object.assign(currentDocument, v);
								break;
							}
						}
					} else {
						let pd: Partial<ParticipantDocument> = {
							blobId: v.blobId,
							identification: v.identification,
							documentTypeId: v.documentTypeId
						};
						if (v.expiryDate) {
							pd.expiryDate = v.expiryDate;
						}
						if (v.documentDate) {
							pd.documentDate = v.documentDate;
						}
						participantDocs.push(<ParticipantDocument>pd);
					}
					CurrentParticipant.save({documents: participantDocs}).then((_response) => {
						sessionStorage.removeItem(CurrentParticipant.storageItem);
						this.close();
					});

				}
			},
			fieldset({
					cls: "",
				},
				textfield({
					label: t("Identification"),
					name: "identification",
					id: "identification",
					placeholder: t("Document number"),
					required: true
				}),

				// this.documentTypeFld = combobox({
				// 	label: t("Document type"),
				// 	name: "documentTypeId",
				// 	id: "documentTypeId",
				// 	required: true,
				// 	dataSource: documentTypesDS,
				// 	listeners: {
				// 		change: (_fld: ComboBox, newValue: number) => {
				// 			if (newValue) {
				// 				this.fileInfoFld!.show();
				// 			}
				// 		}
				// 	}
				// }),
				this.documentTypeFld = select({
					label: t("Document type"),
					name: "documentTypeId",
					id: "documentTypeId",
					required: true,
					options: [],
					// textRenderer: (record): string => {
					// 	let name = record.name;
					// 	const l = record.languages.find((lan: DocumentTypeLanguage) => {
					// 		return lan.language.key.toUpperCase() === sessionStorage.getItem("language");
					// 	})
					// 	if(l) {
					// 		name = l.names;
					// 	}
					// 	return name;
					//
					// },
					listeners: {
						change: (_fld: SelectField, newValue: number) => {
							if (newValue) {
								this.fileInfoFld!.show();
							}
						}
					}
				}),
			),

			fieldset({},
				this.documentDateFld = datefield({
					label: t("Document date"),
					title: t("Document date"),
					id: "documentDate",
					name: "documentDate",
					max: new DateTime().format("Y-m-d"), // today
					listeners: {
						// invalid: IfwInvalidator.setTranslatedDateErrorMsg,
						change: (_field: DateField, newValue: string, _oldValue: string) => {
							this.expirationDateFld!.min = newValue;//DateTime.createFromFormat(newValue, "Y-m-d");
						}
					}
				}),

				this.expirationDateFld = datefield({
					label: t("Document expiration date"),
					title: t("Document expiration date"),
					id: "expiryDate",
					name: "expiryDate",
					min: new DateTime().format("Y-m-d"),
					listeners: {
						// invalid: IfwInvalidator.setTranslatedDateErrorMsg,
						change: (_field: DateField, newValue: string, _oldValue: string) => {
							this.documentDateFld!.max = newValue;//DateTime.createFromFormat(newValue, "Y-m-d");

						}
					}
				}),

				this.fileInfoFld = textfield({
					readOnly: true,
					hidden: true,
					required: true,
					buttons: [
						this.fileUploadBtn = btn({
							type: "button",
							// text: t("Attach files"),
							title: "Upload (gif,jpg,jpeg,png,pdf)",
							icon: "file_upload",
							handler: async () => {
								const file = await browser.pickLocalFiles(false, false, "gif, jpg, jpeg, png, pdf");
								this.mask();
								const response = await ServerApi.upload(file[0]);
								this.unmask();
								if (response.success) {
									const blob = response.data;
									this.fileUploadFld!.value = blob.blobId;
									this.fileInfoFld.value = blob.name + " (" + blob.contentType + ")";
									this.fileUploadDeleteBtn.show();
									this.fileUploadBtn.hide();
								}
							}
						}),
						this.fileUploadDeleteBtn = btn({
							type: "button",
							title: t("Delete"),
							icon: "delete",
							hidden: true,
							handler: async (btn: Button) => {
								this.fileUploadFld!.value = null;
								this.fileInfoFld.value = "";
								this.fileUploadBtn.show();
								btn.hide();
							}
						}),
					],
					label: "Upload (gif,jpg,jpeg,png,pdf)"
				}),

				this.fileUploadFld = textfield({
					hidden: true,
					name: "blobId",
					id: "blobId",
				}),
			),
			tbar({cls: "ifw-bbar"},
				"->",
				btn({
					type: "submit",
					html: t("Save")
				})
			)
		);
		this.items.add(this.form);

		this.on("render", async () => {
			let options:any = [];
			documentTypesStore.load().then((values) => {
				for(const v of values) {
					let name = v.name;
					const l = v.languages.find((lan) => {
						return lan.language.key.toUpperCase() === sessionStorage.getItem("language");
					})
					if(l) {
						name = l.name;
					}
					options.push({value: v.id, name: name});
				}
				this.documentTypeFld.options = options;
			});
		});
	}

	public load(id: string) {
		this.documentId = id;
		const cp = CurrentParticipant.get(),
			participantDocs = cp.documents! as ParticipantDocument[];
		for (const d of participantDocs) {
			if (d.id === id) {
				this.form.value = d;
				if (d.documentBlob as Partial<BlobEntity>) {
					this.fileInfoFld.value = d.documentBlob!.name + " (" + d.documentBlob!.contentType + ")";
				}
				this.fileInfoFld.show();
				// Eeww hackish
				if (d.expiryDate) {
					let dt = new DateTime(d.expiryDate);
					this.expirationDateFld.value = dt.format("Y-m-d");
				}
				if (d.documentDate) {
					let dt = new DateTime(d.documentDate);
					this.documentDateFld.value = dt.format("Y-m-d");
				}
				return;
			}
		}
		Notifier.error("Unable to load current document");
	}
}